import { Navigate, useLocation } from 'react-router-dom'
import { useMe } from '@/hooks/useMe'
import { useAuth } from '@/hooks/useAuth'

interface ProtectedRouteProps {
  children: React.ReactNode
  requiredRoles?: string[]
}

const PUBLIC_ROUTES = ['/login', '/register', '/demo']

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requiredRoles = [] }) => {
  const location = useLocation()
  const { user, isLoading } = useMe()
  const { token } = useAuth()

  // 檢查是否為公開路由
  if (PUBLIC_ROUTES.includes(location.pathname)) {
    return <>{children}</>
  }

  // 如果沒有 token，導向登入頁
  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  if (isLoading) {
    return <div>Loading...</div>
  }

  // 如果有 token 但沒有用戶資料，可能是 token 過期或無效
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  // 密碼過期強制導向已停用（僅保留連線狀態通知）
  // 未來如需恢復 ISO 合規，可取消註解以下區塊
  // if (user.mustChangePassword && location.pathname !== '/settings/password') {
  //   return <Navigate to="/settings/password" replace />
  // }

  // 檢查用戶權限
  if (requiredRoles.length > 0 && !requiredRoles.includes('')) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}

export default ProtectedRoute
